<div class="split-panel flex flex--column nordic-blue-50-bg ps-medium-x ps-large-y rounded-large">
  <div class="split-panel flex-1 flex--basis0">
    <ng-content select="[slot=left]" />
  </div>
  <div class="split-panel flex-1 flex--basis0">
    <ng-content select="[slot=right]" />
  </div>
</div>
